export default __webpack_public_path__ + "pgnv-assets/660841ff4000fcd7e1e022c7112eef64.png";